import script from "./ppt-display.vue?vue&type=script&setup=true&lang=js"
export * from "./ppt-display.vue?vue&type=script&setup=true&lang=js"

import "./ppt-display.vue?vue&type=style&index=0&id=70b84566&scoped=true&lang=css"
import "./ppt-display.vue?vue&type=style&index=1&id=70b84566&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b84566"]])

export default __exports__